export const mergeRichTextContent = (mainContent, additionalContent) => {
  const { content: mainContentArray = [] } = mainContent || {};
  const { content: additionalContentArray = [] } = additionalContent || {};
  return {
    ...mainContent,
    content: mainContentArray.concat(additionalContentArray),
  }
}
